import ModuleByKey from './ModuleByKey';

export default ModuleByKey;
